// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/javascripts/libraries_and_infrequently_changed.js
// MAGIC_DESPROCKET_END
Aedu.I18nHelpers = {
  closestNumberTranslation: function(key, actualNumber) {
    var translations = I18n.t(key);
    var availableNumbers = Object.keys(translations).map(Number);

    if (!_(availableNumbers).isArray() ||
        availableNumbers.length === 0 ||
        availableNumbers.some(isNaN)) {
      throw new Error("invalid key: " + key);
    }

    var closestNumber = _(availableNumbers).min(function(candidateNumber) {
      return Math.abs(candidateNumber - actualNumber);
    });

    return translations[closestNumber.toString()];
  },

  delimitNumber: function(number){
    return I18n.toNumber(number, {precision: 0});
  }
};
